export type RegistryAttestation = {
  id: number
  predicateType: string
  createdAt: string
  runInvocationUri?: string
  workflowFile?: string
  repository: string
}

export type StorageRecord = {
  id: number
  source_registry: string
  registry_url: string
  registry_repository_name: string
  artifact_url: string
  artifact_path: string | null
  created_at: string
  updated_at: string
  status: string
}

export type Artifact = {
  artifact_metadata_id: number
  owner_id: number
  artifact_name: string
  version?: string
  created_at: string
  updated_at: string
  attestation_id?: number
  repository_id?: number
  repository_name?: string
  source_registry?: string
  app_name?: string
  tags?: string[]
  deployment_count?: number
  repository_is_private?: boolean
  digest?: string
}

export function artifactIsDetectedBy(artifact: Artifact): string | undefined {
  const normalizedAppName = artifact.app_name?.trim()
  if (normalizedAppName) {
    return normalizedAppName
  }
  return artifact.source_registry || undefined
}

export type Deployment = {
  deployment_name: string
  logical_environment: string
  physical_environment: string
  cluster: string
  created_at: string
  updated_at: string
  deleted_at?: string
  runtime_risks: string[]
}

export const SortOrder = {
  Newest: '2',
  Oldest: '1',
} as const

export type PageInfo = {
  totalCount: number
  hasNextPage: boolean
  hasPreviousPage: boolean
  currentPage: number
  offset: number
  pageSize: number
  totalPages: number
}

export type DeploymentPageInfo = {
  page: number
  perPage: number
  totalCount: number
  totalPages: number
  hasNextPage: boolean
  hasPreviousPage: boolean
}

export type ArtifactRegistryShowRoutePayload = {
  artifact: Artifact
  attestations: RegistryAttestation[]
  deployments: Deployment[]
  storageRecord?: StorageRecord
  deploymentPageInfo?: DeploymentPageInfo
}

export type ArtifactRegistryIndexPayload = {
  artifacts: Artifact[]
  totalCount?: number
  pageInfo?: PageInfo
}
